/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21.1594 16.3422c.7229-.89 1.4411-1.9371 2.1551-3.1649L24 11.9984l-1.0149-1.7333c-.5655-.9416-1.1336-1.7678-1.7045-2.4914C18.2768 3.967 15.1941 3 11.9995 3 8.8471 3 5.804 4.0083 2.8397 7.6578c-.723.89-1.4412 1.937-2.1551 3.1649L0 12l.6846 1.1773.331.5604c.6372 1.061 1.2778 1.9754 1.922 2.7616C5.8716 20.0793 8.8823 21 11.9995 21c3.1525 0 6.1956-1.0083 9.1599-4.6578ZM2.2701 12.9844l.0055.0089c.6058.9899 1.2108 1.8318 1.815 2.5466 2.6486 3.1329 5.2832 3.8237 7.9089 3.8237 2.6568 0 5.323-.7753 8.0026-3.9757.6825-.8151 1.3658-1.7876 2.0501-2.9446.0368-.0623.0737-.125.1105-.1884l.1459-.2533-.4681-.8018a26.307 26.307 0 0 0-.1099-.1814l-.0084-.0138c-.5376-.8777-1.0746-1.6362-1.6109-2.2913-2.6107-3.1888-5.2077-3.9301-7.7959-4.0685l-.3159-.0084c-2.6567 0-5.323.7753-8.0025 3.9757-.6825.8151-1.3659 1.7876-2.0502 2.9446-.0368.0623-.0736.125-.1104.1884l-.1487.2533.4708.8018c.0373.062.0745.1234.1117.1842ZM15 12c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3 1.3431 3 3 3 3-1.3431 3-3Zm-7.5 0c0-2.4853 2.0147-4.5 4.5-4.5s4.5 2.0147 4.5 4.5-2.0147 4.5-4.5 4.5-4.5-2.0147-4.5-4.5Z"
    clipRule="evenodd"
  />,
  'ShowPassword'
);
